// extracted by mini-css-extract-plugin
export default {"text_white":"UserCard_text_white__KxAy7","card_wrapper":"UserCard_card_wrapper__OoHON","button_wrapper":"UserCard_button_wrapper__1g3CM"};